import React from 'react';
import Banner from './Banner';
import More from './More';
import Hire from './Hire';
import ReachOut from './ReachOut';


const Home = () => {

    return (
        <div>
            <Banner></Banner>
            <More></More>
            <Hire></Hire>
            <ReachOut></ReachOut>
        </div>
    );
};

export default Home;